import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const NO_DEV_TIMEOUT = false; // Set to true to suppress extending the timeout in development mode.

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
	constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (isDevMode() && !NO_DEV_TIMEOUT) {
			// 5 minute timeout in development.
			this.defaultTimeout = 5 * 60 * 1_000;
		}

		const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
		const timeoutValueNumeric = Number(timeoutValue);

		return next.handle(req).pipe(
			timeout(timeoutValueNumeric),
			catchError((err) => {
				return throwError(() => err);
			}),
		);
	}
}
